import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import NavigationManager from './NavigationManager';

class NavigationStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return {
      collections: [],
      categories: [],
      reports_collection_id: null,
      has_any_archived_collection: false,
      has_any_unread_news: false,
      unseen_product_focuses: [],
      notification_modal_showed: false,
    };
  }

  reduce(state, action) {
    switch (action.actionType) {
      case ActionTypes.NAVIGATION_GET:
      case ActionTypes.USER_STORE_UPDATE_LANGUAGE_COMPLETED:
        NavigationManager.getNavigation();
        return state;

      case ActionTypes.NAVIGATION_GET_COMPLETE:
        return action.navigation;

      default:
        return state;
    }
  }
}

export default new NavigationStore();
